import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import getCategories from '../../../client/fetch/categories';
import DesktopMenu from './desktop-menu/DesktopMenu';
import MobileMenu from './mobile-menu/MobileMenu';
import getNavigation from '../../../client/fetch/get-navigation';
import isMonetateGroup from '../../utils/monetate/isMonetateGroup';
import overrideCategory from '../../../lib/overrides/overrideCategory';
import mergeContentBlocks from './merge-content-blocks';

export const fetchChildCategories = isNavigationApi => ({ id }) =>
  isNavigationApi
    ? getNavigation({ id, depth: 4 })
    : getCategories({ id, depth: 4 });

function Navigation({ mobileNavShown }) {
  const { categories, features, categoryOverrides, contentBlocks } = useContext(
    EnvVarsFeaturesContext
  );
  const isNavigationApi = isMonetateGroup(features, 'navigation-service');

  const overrideCategories = useMemo(
    () =>
      categoryOverrides
        ? overrideCategory(categories, categoryOverrides)
        : categories,
    [categories, categoryOverrides]
  );

  const enrichedCategories = useMemo(
    () =>
      contentBlocks?.length
        ? mergeContentBlocks(features, overrideCategories, contentBlocks)
        : overrideCategories,
    [overrideCategories, contentBlocks]
  );

  const menus = [
    {
      id: 'shop-by-department',
      name: 'Shop by department',
      child: enrichedCategories.child,
    },
  ];

  const fetch = fetchChildCategories(isNavigationApi);

  return (
    <>
      {mobileNavShown ? (
        <MobileMenu
          menus={menus}
          fetchChildCategories={fetch}
          hasContentBlocks={!!contentBlocks}
        />
      ) : (
        <DesktopMenu child={enrichedCategories.child} />
      )}
    </>
  );
}

Navigation.propTypes = {
  mobileNavShown: PropTypes.bool.isRequired,
};

export default Navigation;
